import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import {displayParentLineagePath} from 'registry/child-entities/ParentLineagePathUtil';
import {SchemaField} from 'schemas/fields/SchemaFieldConstants';
import getTestProps from 'test/lib/cypress/getTestProps';
import {GRAY_DARKER} from 'ui-library/Colors';
import {FloatingPlacement} from 'ui-library/floating-ui/FloatingConstants';
import Tooltip from 'ui-library/floating-ui/Tooltip';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';
import HelpIcon from 'ui-library/icons/HelpIcon';

import {getRequiredLinkEntitySchemaFieldPath} from './FieldPathUtil';
import getIconAndLabel, {FieldDefinitionLabelProps} from './GetFieldLabelAndIcon';

export default function FieldDefinitionLabel({
  inEditMode = false,
  ...props
}: FieldDefinitionLabelProps & {field: SchemaField}): JSX.Element {
  const {icon, label} = getIconAndLabel(props);
  const requiredLinkEntitySchemaFieldPath = getRequiredLinkEntitySchemaFieldPath(props.field);
  return (
    <div
      className={css(styles.labelStyle)}
      {...getTestProps({component: 'FieldDefinitionLabel', element: 'root'})}
    >
      <BenchlingIcon icon={icon} className={css(styles.iconStyle)} />
      {label}
      {requiredLinkEntitySchemaFieldPath && !inEditMode && (
        <div className={css(styles.lineageEnforcementDisplay)}>
          Lineage enforced
          <Tooltip
            text={displayParentLineagePath({path: requiredLinkEntitySchemaFieldPath.edges})}
            placement={FloatingPlacement.LEFT}
          >
            <HelpIcon className="tagSchemaSettings-helpIcon u-tiny-spacing-left" />
          </Tooltip>
        </div>
      )}
    </div>
  );
}

const styles = StyleSheet.create({
  iconStyle: {
    color: GRAY_DARKER,
    marginRight: '10px',
    height: '12px',
    width: '12px',
  },
  labelStyle: {
    alignItems: 'center',
    wordWrap: 'normal',
  },
  lineageEnforcementDisplay: {
    fontSize: '12px',
    color: GRAY_DARKER,
    whiteSpace: 'nowrap',
  },
});
